export const state = {
    schools: {},
    isLoading: false,
    currentProductId: null,
    schoolPerPage: 10,
    totalRecords: 10,
    activePage: 1,
    addOns: [],
    schoolList: schoolNamespace =>
      Object.values(schoolNamespace.schools)
        .sort((a, b) => {
          if (a.createdAt > b.createdAt) {
            return 1
          } else if (a.createdAt < b.createdAt) {
            return -1
          }

          return 0
        })
        .slice(0, schoolNamespace.schoolPerPage)
  }
